import { render, staticRenderFns } from "./UploadPhoto.vue?vue&type=template&id=520bef51"
import script from "./UploadPhoto.vue?vue&type=script&lang=js"
export * from "./UploadPhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports